<template>
  <div class="main">
    <div class="main-title">CA办理</div>
    <div class="main-top">
      <ca></ca>
    </div>
  </div>
</template>

<script>
import Ca from "./components/ca.vue";

export default {
  components: {
    Ca
  },
  data() {
    return {};
  },
  methods: {
    queryData() {
      const that = this;
      that.$get(
        `${this.$store.state.api.webUrl}/navigation/getSearchData.json`,
        {
          province: '河北省',
          city: '石家庄市',
        },
        (data) => {
          if (data) {
            that.$store.commit(
              "dealcenter/updateactiveName",
              "cabl"
            );
            that.$store.commit("dealcenter/updateData", data);
          }
        }
      );
    },
  },
  created() {
    this.$store.dispatch("analysis/updateHits", {
      visitlocation: "CA办理",
    });
    this.queryData();
  }
};
</script>

<style scoped lang="scss">
@import "@css/var.scss";

.main {
  width: 1200px;

  .main-title {
    font-size: 16px;
    font-weight: bold;
    position: absolute;
    left: 20px;
    top: 10px;
    z-index: 100;
  }

  .main-top {
    background-color: white;
    overflow: hidden;
    padding: 40px 0 45px 60px;
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
}
</style>
